import React from 'react';

// Clapperboard upload icon. Reproduces the reactbits/lucide "clapperboard"
// artwork; the top flap ("clap") hinges open/shut via a CSS keyframe animation
// (see .ownavClapFlap in site-global.css) so we don't need framer-motion. Plays
// once on mount and loops while the Upload control is hovered.
export const ClapUploadIcon = ({ size = 20, className = '' }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ overflow: 'visible' }}
    aria-hidden="true"
  >
    <g className="ownavClapFlap">
      <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z" />
      <path d="m6.2 5.3 3.1 3.9" />
      <path d="m12.4 3.4 3.1 4" />
    </g>
    <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
  </svg>
);

export default ClapUploadIcon;
